var _rect, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMkgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 426,
    height: 120,
    viewBox: "0 0 426 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 92,
    height: 92,
    rx: 14,
    fill: "#1F3A5F"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 79,
    textAnchor: "middle",
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 44,
    fontWeight: 700,
    fill: "#FFFFFF"
  }, "MKG")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 66,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 46,
    fontWeight: 700,
    fill: "#1F3A5F"
  }, "MKG")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 98,
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 22,
    fill: "#5B6B7F"
  }, "Order import")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMkgLogo);
export default __webpack_public_path__ + "static/media/mkg_logo.dd691a8ec17865d8e8827b992cd313fa.svg";
export { ForwardRef as ReactComponent };